/**
 *
 * Comparação da password com a confirmação
 * de password. Caso sejam diferentes, é apresentado
 * uma mensagem de erro ao utilizador.
 *
 * @param {String} value
 * @param {Object} vm
 * @output {Boolean}
 *
*/

const sameAsPassword = ( value, vm ) => {
    // se não existir o parametro
    // não é necessário executar a validação.
    if ( !vm.validationParameter )
        return true;

    return value === vm.validationParameter;
};

export default {
    sameAsPassword
};